import styled from 'styled-components';
import UICardWrapper from 'UIComponents/card/UICardWrapper';
import UIFlex from 'UIComponents/layout/UIFlex';
import { SkeletonBlock, SkeletonWrapper } from '../Skeleton';
import { device } from '../../constants/StyledComponentConstants';
import { theme } from 'academy-common-lib/utils/Styling';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ContentCardSkeletonWrapper = styled(UICardWrapper).withConfig({
  displayName: "ContentCardSkeleton__ContentCardSkeletonWrapper",
  componentId: "sc-17i81b5-0"
})(["height:326px;border-radius:3px;background-color:", ";@media screen and ", "{&:not(:last-child){margin-right:32px;}}"], ({
  $use
}) => $use === 'on-light' ? theme.colors.OLAF : $use === 'on-dark' ? theme.colors.MONOLITH : 'rgba(34,88,130,0.2)', device.mobile);
const ContentCardSkeleton = ({
  use = 'on-light'
}) => {
  let color;
  let shimmercolor;
  switch (use) {
    case 'on-dark':
      color = theme.colors.PANTERA;
      shimmercolor = theme.colors.OBSIDIAN;
      break;
    case 'on-blue':
      shimmercolor = '#3F8FA2';
      color = '#225882';
      break;
    case 'on-light':
    default:
      color = theme.colors.KOALA;
      break;
  }
  return /*#__PURE__*/_jsx(ContentCardSkeletonWrapper, {
    $use: use,
    className: "card-skeleton",
    "data-test-id": "card-skeleton",
    children: /*#__PURE__*/_jsxs(SkeletonWrapper, {
      shimmercolor: shimmercolor,
      children: [/*#__PURE__*/_jsx(SkeletonBlock, {
        className: "ribbon",
        color: color,
        style: {
          height: 10
        }
      }), /*#__PURE__*/_jsx("div", {
        className: "section-with-bottom-hr",
        style: {
          borderBottom: `${color} solid 1px`,
          height: 120
        },
        children: /*#__PURE__*/_jsx("div", {
          style: {
            padding: '0 10px'
          },
          children: /*#__PURE__*/_jsxs(UIFlex, {
            justify: "between",
            children: [/*#__PURE__*/_jsxs(UIFlex, {
              direction: "column",
              children: [/*#__PURE__*/_jsx(SkeletonBlock, {
                className: "category",
                color: color,
                style: {
                  height: 16,
                  width: '40%',
                  marginTop: 10
                }
              }), /*#__PURE__*/_jsx(SkeletonBlock, {
                className: "title",
                color: color,
                style: {
                  height: 20,
                  width: '90%',
                  marginTop: 12
                }
              }), /*#__PURE__*/_jsx(SkeletonBlock, {
                className: "title",
                color: color,
                style: {
                  height: 20,
                  width: '75%',
                  marginTop: 12
                }
              })]
            }), /*#__PURE__*/_jsx(SkeletonBlock, {
              className: "icon",
              color: color,
              style: {
                height: 50,
                width: 50,
                borderBottomLeftRadius: 50,
                borderBottomRightRadius: 50
              }
            })]
          })
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "section",
        style: {
          height: 150
        },
        children: /*#__PURE__*/_jsxs("div", {
          style: {
            padding: '0 10px'
          },
          children: [/*#__PURE__*/_jsx(SkeletonBlock, {
            className: "course-type",
            color: color,
            style: {
              height: 20,
              width: '25%',
              marginTop: 12
            }
          }), /*#__PURE__*/_jsx(SkeletonBlock, {
            className: "description-line",
            color: color,
            style: {
              height: 14,
              width: '95%',
              marginTop: 24
            }
          }), /*#__PURE__*/_jsx(SkeletonBlock, {
            className: "description-line",
            color: color,
            style: {
              height: 14,
              width: '98%',
              marginTop: 12
            }
          }), /*#__PURE__*/_jsx(SkeletonBlock, {
            className: "description-line",
            color: color,
            style: {
              height: 14,
              width: '80%',
              marginTop: 12
            }
          }), /*#__PURE__*/_jsx(SkeletonBlock, {
            className: "description-line",
            color: color,
            style: {
              height: 14,
              width: '82%',
              marginTop: 12
            }
          })]
        })
      })]
    })
  });
};
export default ContentCardSkeleton;